import api from './api';
import {
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  TwoFactorResponse,
} from '../types/auth.types';

export const AuthService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  register: async (userData: RegisterRequest): Promise<any> => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  logout: async (): Promise<any> => {
    const response = await api.post('/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return response.data;
  },

  getProfile: async (): Promise<any> => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  generateTwoFactorSecret: async (): Promise<TwoFactorResponse> => {
    const response = await api.post<TwoFactorResponse>('/auth/2fa/generate');
    return response.data;
  },

  enableTwoFactor: async (twoFactorCode: string): Promise<any> => {
    const response = await api.post('/auth/2fa/enable', { twoFactorCode });
    return response.data;
  },

  disableTwoFactor: async (twoFactorCode: string): Promise<any> => {
    const response = await api.post('/auth/2fa/disable', { twoFactorCode });
    return response.data;
  },
};